import { SpacerVertical, Typography } from '@klarna/bubble-ui'

import React from 'react'
import { buildId } from 'common/utils/string'
import styles from './index.css'

/*
 * bubble-ui is deprecating CenteredContent,
 * this is the recomended way of replicating
 * its funcionality
 * https://github.com/klarna/bubble-ui/wiki/FAQ#i-hear-centeredcontent-is-deprecated-what-should-i-use-instead
 */

function CenteredContent({
  id,
  title,
  summary,
  illustration
}: {
  id?: string
  title?: React.ReactNode
  summary?: React.ReactNode
  illustration?: React.ReactNode
}) {
  return (
    <div id={id} className={styles.wrapper}>
      {illustration && (
        <div id={buildId(id, 'illustration')} className={styles.illustration}>
          {illustration}
        </div>
      )}
      {title && (
        <Typography
          id={buildId(id, 'title')}
          textToken="text-style/headings/titles/bold/tertiary"
          align="center"
        >
          {title}
        </Typography>
      )}
      {title && summary && (
        <>
          <SpacerVertical spaceToken="space.300" />
        </>
      )}
      {summary && (
        <Typography
          id={buildId(id, 'summary')}
          textToken="text-style/text/super-paragraphs/body/regular"
          align="center"
        >
          {summary}
        </Typography>
      )}
    </div>
  )
}

export default CenteredContent
